<template>
  <SettingsLayout :role="role" :user="user" @select="handleSelect">
    <component :is="currentComponent" :profile="profile" :loading="loading" @update-profile="handleUpdate" />
  </SettingsLayout>
</template>

<script>
import { markRaw, ref } from "vue";

import SettingsLayout from "@/layout/SettingsLayout.vue";
import { useAuthStore } from "@/stores/authStore";
import { fetchInstituteProfile, updateInstitute, updateUsername } from "@/api/institutes";
import { useRouter } from "vue-router";
import { notifyError, notifySuccess } from "@/utils/notification";
import InstituteProfileForm from "@/components/settings/institute/InstituteProfileForm.vue";
import InstituteSecurityForm from "@/components/settings/institute/InstituteSecurityForm.vue";
import InstitutePhotoForm from "@/components/settings/institute/InstitutePhotoForm.vue";
import InstituteSubscriptionPage from "@/components/settings/institute/subscription/SubscriptionPage.vue";
import InstitutePaymentMethodPage from "@/components/settings/institute/InstitutePaymentMethodPage.vue";

const loading = ref(false);

export default {
  components: {
    SettingsLayout,
  },
  data() {
    return {
      userId: undefined,
      user: null,
      role: "Institution",
      currentComponent: markRaw(InstituteProfileForm),
      componentMap: {
        InstituteProfileForm: markRaw(InstituteProfileForm),
        InstituteSecurityForm: markRaw(InstituteSecurityForm),
        InstitutePhotoForm: markRaw(InstitutePhotoForm),
        InstituteSubscriptionPage: markRaw(InstituteSubscriptionPage),
        InstitutePaymentMethodPage: markRaw(InstitutePaymentMethodPage),
      },
    };
  },
  mounted() {
    loading.value = true;
    this.userId = useAuthStore().user.userId;
    if (!this.userId) {
      this.userId = useAuthStore().user._id;
    }
    if (!this.userId) {
      useRouter().push("/login")
      return
    }
    this.role = useAuthStore().user.role;
    this.user = useAuthStore().user;
    this.fetchUserData();
    loading.value = false;
  },
  computed: {
    profile() {
      return useAuthStore().user;
    }
  },
  methods: {
    async fetchUserData() {
      const user = await fetchInstituteProfile();
      useAuthStore().updateLocalUser(user.data.data);
    },
    async handleUpdate(payload) {
      try {
        await updateInstitute(payload);
        if (payload.instituteName) {
          await updateUsername({ username: payload.instituteName });
        }
        notifySuccess("Success", "Your profile has been updated.");
        await this.fetchUserData();
      } catch {
        notifyError("Oops! Something went wrong", "We couldn’t complete your request. Please try again or contact support if the problem persists.");
      }
    },

    handleSelect(componentName) {
      this.currentComponent = this.componentMap[componentName] || this.componentMap.InstituteProfileForm;
    },
  },
};
</script>
